var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPneumology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M17.667,11.856c0,0-1.074-7.545,3.427-5.407 c0,0,10.383,4.359,8.593,20.37c0,0-7.212,2.389-10.128-1.299C19.559,25.519,17.718,22.753,17.667,11.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14.544,11.856c0,0,1.074-7.545-3.427-5.407 c0,0-10.383,4.359-8.593,20.37c0,0,7.212,2.389,10.127-1.299C12.651,25.519,14.493,22.753,14.544,11.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M26.814,20.985 c-0.065-0.108-1.425-2.312-4.591-3.627c2.727-0.424,4.324-2.047,4.402-2.129c0.123-0.127,0.119-0.33-0.008-0.453 c-0.062-0.06-0.142-0.09-0.222-0.09c-0.084,0-0.168,0.033-0.23,0.098c-0.021,0.022-2.138,2.166-5.572,2.027 c-0.004,0-0.008,0.001-0.012,0.001c-0.033-0.009-0.066-0.018-0.1-0.026c-0.062-0.019-0.71-0.222-1.453-0.691 c1.015-0.083,1.98-0.503,2.833-1.24c0.849-0.733,1.287-1.518,1.305-1.551c0.085-0.155,0.029-0.349-0.125-0.435 c-0.049-0.027-0.102-0.04-0.155-0.04c-0.113,0-0.222,0.06-0.281,0.165c-0.004,0.007-0.411,0.731-1.179,1.389 c-0.983,0.843-2.08,1.197-3.261,1.056c-0.922-0.843-1.436-1.88-1.528-3.091V3.821h-0.575h-0.066h-0.575v8.526 c-0.092,1.211-0.606,2.248-1.528,3.091c-1.181,0.141-2.279-0.213-3.261-1.056c-0.768-0.658-1.175-1.382-1.179-1.389 c-0.059-0.105-0.168-0.165-0.281-0.165c-0.052,0-0.106,0.013-0.155,0.04c-0.155,0.086-0.211,0.28-0.125,0.435 c0.018,0.033,0.456,0.817,1.305,1.551c0.853,0.738,1.818,1.157,2.833,1.24c-0.743,0.469-1.39,0.672-1.453,0.691 c-0.034,0.008-0.066,0.018-0.1,0.026c-0.004,0-0.008-0.001-0.012-0.001c-3.434,0.139-5.551-2.006-5.572-2.027 c-0.063-0.065-0.147-0.098-0.23-0.098c-0.08,0-0.16,0.03-0.222,0.09c-0.127,0.123-0.131,0.325-0.008,0.453 c0.078,0.082,1.675,1.706,4.402,2.129c-3.166,1.315-4.526,3.519-4.591,3.627c-0.091,0.152-0.042,0.348,0.109,0.44 c0.151,0.091,0.348,0.042,0.439-0.109c0.017-0.029,1.791-2.889,5.946-3.91l0.012-0.003c0.017-0.005,0.185-0.054,0.446-0.16 c-0.798,1.055-1.371,2.032-1.71,2.921c-0.188,0.493-0.275,0.888-0.31,1.187c-0.042,0.353,0.294,0.633,0.635,0.532l-0.013-0.105 c-0.005-0.019-0.357-1.604,2.872-5.329l0,0c0.019-0.006,0.037-0.011,0.056-0.017c-0.001-0.01-0.002-0.021-0.004-0.031 c0.023-0.017,0.046-0.033,0.069-0.05c1.278-0.943,2.046-2.202,2.237-3.656c0.191,1.453,0.959,2.712,2.237,3.656 c0.023,0.017,0.046,0.034,0.069,0.05c-0.001,0.01-0.002,0.021-0.004,0.031c0.019,0.005,0.037,0.01,0.056,0.017l0,0 c3.229,3.725,2.956,5.223,2.859,5.434l0,0c0.479,0.081,0.676-0.179,0.635-0.532c-0.035-0.299-0.122-0.693-0.31-1.187 c-0.339-0.889-0.912-1.866-1.71-2.921c0.261,0.106,0.43,0.155,0.446,0.16l0.012,0.003c4.154,1.021,5.928,3.881,5.946,3.91 c0.091,0.151,0.288,0.2,0.439,0.109C26.856,21.333,26.905,21.136,26.814,20.985z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M27.385,8.153 c0,1.685-1.366,3.051-3.051,3.051s-3.051-1.366-3.051-3.051s1.366-3.051,3.051-3.051S27.385,6.468,27.385,8.153z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "26.4,7.283 25.191,7.283  25.191,6.074 23.531,6.074 23.531,7.283 22.322,7.283 22.322,8.943 23.531,8.943 23.531,10.152 25.191,10.152 25.191,8.943  26.4,8.943  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPneumology);
export default __webpack_public_path__ + "static/media/pneumology.fa95928938843d748f83dfc069ba650b.svg";
export { ForwardRef as ReactComponent };